// extracted by mini-css-extract-plugin
export default {"logo":"wHvODQQIuH+n5cMzFa580w=="};